import '../Assets/Styles/register.css';
import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useMediaQuery } from 'react-responsive'

import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';

import Box from '@mui/material/Box';

// Load Actions
import * as AppActions from '../Store/Actions/App';

import {
    disableBodyScroll,
    enableBodyScroll
} from './Utils';


// UpdateService dialog component
const TermsView = (props) => {

// set vars from props
const { 
    termsModal,
    setTermsModal,
    scrollBlock
} = props;		

const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

const [loading, setLoading] = React.useState(true);



const footerContent = (
    <div className="modalFooterButtonsEnd">

        <div>
            <Button label="Fechar" icon="pi pi-times" className="p-button-text" onClick={() => close()} />
        </div>
        
    </div>
);		
    

// Execute when dialog opens
React.useEffect(() => {

    // Only r]uns when  dialog opens
    if (termsModal) {

        disableBodyScroll();
        
    } // end if
    
    // Runs when UNMOUNT component
    return () => {
        enableBodyScroll();
    };    
    
            
},[termsModal]);

const close = ()=> {
    setTermsModal(false);
    enableBodyScroll();
}
    
    return (
    <>
            <Dialog header="Termos e condições de uso" visible={termsModal} style={{ width: isMobile ? '100vw' : '55vw', height: isMobile ? '100vh' : 'auto' }} breakpoints={{ '1400px': '75vw','960px': '80vw', '641px': '100vw' }} onHide={() => close()} footer={footerContent} >

                <Box
                  sx={{
                    width: "100%",
                  }}
                  className="terms"
                >
                    
                    <Divider />
                    
                        <h2>1. Termos e Condições</h2>
                        <p>
                            Todas as reservas estão sujeitas à disponibilidade, e as tarifas podem variar dependendo das políticas e preços do hotel. Restrições ou condições especiais, como políticas de cancelamento e reembolso, podem ser aplicadas a determinadas tarifas. Por favor, revise os detalhes específicos de cada reserva antes de confirmá-la.
                        </p>

                        <h2>2. Antecedência e disponibilidade através da plataforma</h2>
                        <p>
                            Reservas só podem ser feitas com antecedência mínima de 3 dias corridos da data do serviço. Recomendamos avisar nossa central de atendimento assim que uma reserva for realizada, para que possamos acompanhar o processo.
                        </p>

                        <h2>3. Pedidos com menos de três dias corridos e condições excepcionais de pagamento</h2>
                        <p>
                            Reservas solicitadas com prazo inferior a três dias antes do check-in e/ou pagamentos realizados com cartão de terceiros não poderão ser efetuados pela plataforma. Nestes casos, é necessário entrar em contato com a central de atendimento.
                        </p>

                        <h2>4. Pagamentos através da plataforma</h2>
                        <p>
                            Os pagamentos através da plataforma deverão ser feitos exclusivamente através do cartão de crédito do titular do serviço (passageiro líder), respeitando a grafia de seu nome conforme inserido na reserva e com a data de vencimento do cartão no formato DD/AAAA para que o pagamento seja aprovado.
                        </p>

                        <h2>5. Preços</h2>
                        <p>
                            As tarifas exibidas estão sujeitas a alterações e podem incluir condições especiais impostas pelos hotéis. Impostos, taxas e cobranças adicionais podem ser aplicados e serão informados no momento da cotação.
                        </p>
                        <p>
                            A tarifa para ocupação dupla é garantida, salvo indicação contrária. Acomodações para mais de dois hóspedes podem implicar cobranças adicionais, pagáveis diretamente ao hotel.
                        </p>

                        <h2>6. Requisitos de Check-In</h2>
                        <p>
                            Um documento de identificação válido e um cartão de crédito ou débito em nome do titular da reserva são necessários no check-in. A idade mínima para check-in será especificada no momento da reserva.
                        </p>
                        <p>
                            Os cartões de crédito ou débito podem ser pré-autorizados para cobranças incidentais, e o valor exigido pode variar de acordo com o hotel.
                        </p>

                        <h2>7. Cancelamentos e Alterações</h2>
                        <p>
                            As políticas de cancelamento e alteração variam de acordo com o hotel e o tipo de reserva. Algumas reservas podem ter multas associadas em caso de cancelamento. Consulte a política de cancelamento fornecida durante o processo de reserva para mais detalhes.
                        </p>
                        <p>
                            Vale ressaltar que não trabalhamos com reservas "não reembolsáveis". O não comparecimento na primeira noite da reserva, que não tenha sido previamente avisado, pode resultar no cancelamento das noites restantes, sem direito a reembolso.
                        </p>
                        <p>
                            Para cancelamentos realizados com pagamento via cartão de crédito, será aplicada uma taxa administrativa de 3,5%.
                        </p>

                        <h2>8. Necessidades Especiais e Solicitações</h2>
                        <p>
                            Caso possua necessidades especiais (ex.: acomodações para deficiência ou preferências de quarto), entre em contato diretamente com nossa equipe de suporte após a reserva para tentar garantir que seus requisitos possam ser atendidos. Nossa plataforma não garante essas solicitações.
                        </p>

                        <h2>9. Impostos e Taxas</h2>
                        <p>
                            As informações sobre impostos e taxas incluem encargos aplicáveis ao hotel, como impostos de ocupação, impostos sobre vendas e outras cobranças exigidas por lei. Adicionalmente, alguns hotéis podem cobrar taxas obrigatórias, como, por exemplo, taxas de turismo e resort, que devem ser quitadas diretamente no momento do check-out.
                        </p>

                        <h2>10. Isenção de Responsabilidade</h2>
                        <p>
                            Nossa plataforma atua como facilitadora de reservas e não se responsabiliza por eventuais discrepâncias nos serviços ou comodidades oferecidos pelo hotel, que ficam a critério da administração do mesmo. No entanto, nossa equipe está sempre à disposição e fará o possível para intermediar e atender às solicitações dos clientes, buscando alcançar o resultado desejado.
                        </p>
                        <p>
                            Todas as reservas estão sujeitas aos termos e condições do respectivo hotel. Ao concluir uma reserva em nosso site, você reconhece e aceita estes termos e condições.
                        </p>

                        <h2>11. Contato</h2>
                        <p>
                            Para dúvidas ou assistência adicional, entre em contato com nossa equipe de suporte.
                        </p>
                        
                        
            </Box>
            </Dialog>	
    </>	
    );
    
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions }, dispatch);

export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(TermsView);	
